import moment from 'moment';
import React from 'react';
import {
  ReviewDivider,
  ReviewDoubleRow,
  ReviewItem,
  ReviewItemLabel,
  ReviewItemValue,
  ReviewSection,
  ReviewSectionTitle
} from '../../../components/WizardV2/wizardStylesV2';

function isUnsetSlotTime(v) {
  return v == null || v === '' || v === -1 || v === '-1';
}

export function formatBlockLength(startDate, endDate) {
  if (!startDate) return '—';
  const start = moment(startDate);
  if (!start.isValid()) return '—';
  if (!endDate) return '—';
  const end = moment(endDate);
  if (!end.isValid()) return '—';
  const days = end.diff(start, 'days') + 1;
  if (days <= 0) return '—';
  return days === 1 ? '1 day' : `${days} days`;
}

function formatDateField(v) {
  if (v == null || v === '') return '—';
  const m = moment.isMoment(v) ? v : moment(v);
  if (!m.isValid()) return '—';
  return m.format('MMMM D, YYYY');
}

function formatTime(v) {
  if (isUnsetSlotTime(v)) return '—';
  const m = moment.parseZone(v);
  if (!m.isValid()) return '—';
  return m.format('h:mm a');
}

function AddBlockConfirmationStepV2({ t, getValues, amenities }) {
  const summaryAmenityName = () => {
    const id = getValues('amenity_id');
    const row = amenities.find((a) => String(a.id) === String(id));
    return row?.description ?? '—';
  };

  const startDate = getValues('startDate');
  const endDate = getValues('endDate');

  return (
    <>
      <ReviewDivider />
      <ReviewSection>
        <ReviewSectionTitle>
          {t('Booking Details', { defaultValue: 'Booking Details' })}
        </ReviewSectionTitle>
        <ReviewDoubleRow>
          <ReviewItem>
            <ReviewItemLabel>{t('Amenity', { defaultValue: 'Amenity' })}</ReviewItemLabel>
            <ReviewItemValue>{summaryAmenityName()}</ReviewItemValue>
          </ReviewItem>
          <ReviewItem>
            <ReviewItemLabel>{t('Length', { defaultValue: 'Length' })}</ReviewItemLabel>
            <ReviewItemValue>
              {formatBlockLength(startDate, getValues('endDate'))}
            </ReviewItemValue>
          </ReviewItem>
        </ReviewDoubleRow>
        <ReviewDoubleRow>
          <ReviewItem>
            <ReviewItemLabel>{t('Start Date', { defaultValue: 'Start Date' })}</ReviewItemLabel>
            <ReviewItemValue>{formatDateField(startDate)}</ReviewItemValue>
          </ReviewItem>
          <ReviewItem>
            <ReviewItemLabel>{t('End Date', { defaultValue: 'End Date' })}</ReviewItemLabel>
            <ReviewItemValue>{formatDateField(endDate)}</ReviewItemValue>
          </ReviewItem>
        </ReviewDoubleRow>
        <ReviewDoubleRow>
          <ReviewItem>
            <ReviewItemLabel>{t('Start Time', { defaultValue: 'Start Time' })}</ReviewItemLabel>
            <ReviewItemValue>{formatTime(getValues('startTime'))}</ReviewItemValue>
          </ReviewItem>
          <ReviewItem>
            <ReviewItemLabel>{t('End Time', { defaultValue: 'End Time' })}</ReviewItemLabel>
            <ReviewItemValue>{formatTime(getValues('endTime'))}</ReviewItemValue>
          </ReviewItem>
        </ReviewDoubleRow>
        <ReviewItem>
          <ReviewItemLabel>{t('Reason', { defaultValue: 'Reason' })}</ReviewItemLabel>
          <ReviewItemValue>{getValues('reason') || '—'}</ReviewItemValue>
        </ReviewItem>
      </ReviewSection>
    </>
  );
}

export default AddBlockConfirmationStepV2;
